<template>
  <div>
    <detail acc-type="Farm" :hiddenLabel="true" />
  </div>
</template>

<script>
import Detail from "@/components/shared/Conversations/Detail.vue";

export default {
  components: {
    Detail
  }
};
</script>

<style scoped>
</style>
